export const DIAGRAM_NODE_CITATIONS: Record<string, Record<string, number[]>> = {
  "hardcoded-p2p-001": {
    "p2p-requisition": [1],
    "p2p-req-approval": [1],
    "p2p-vendor-po": [6, 8],
    "p2p-po-approval": [2, 8],
    "p2p-goods-receipt": [4],
    "p2p-invoice": [5],
    "p2p-three-way": [3, 5],
    "p2p-invoice-approval": [3],
    "p2p-payment": [7],
    "p2p-payment-auth": [7],
    "p2p-gl-posting": [7],
  },
  "hardcoded-o2c-001": {
    "o2c-order": [10, 14],
    "o2c-credit-check": [10, 14],
    "o2c-order-entry": [14],
    "o2c-pick-pack": [15],
    "o2c-shipment": [9, 11, 15],
    "o2c-billing": [9, 11, 15],
    "o2c-revenue": [9],
    "o2c-payment-receipt": [12],
    "o2c-apply-payment": [12],
    "o2c-collections": [13],
  },
  "hardcoded-it-access-001": {
    "it-request": [16, 22],
    "it-manager-approval": [16, 22],
    "it-system-owner-approval": [16, 22],
    "it-security-review": [17, 23],
    "it-provision": [18],
    "it-monitor": [19],
    "it-termination": [20],
    "it-disable-access": [21],
    "it-verify": [21],
    "it-audit": [19],
  },
};
